module.exports = __webpack_public_path__ + "static/media/system_and_Device.8f3a385e.svg";